import React, { Component, useEffect, useState } from "react";
import { FormProvider, useForm, Controller } from "react-hook-form";
import { Button, Spinner } from "react-bootstrap";
import SaveIcon from "@mui/icons-material/SaveRounded";
import _ from "lodash";
import ApiDynamicSetting from "../../../../core/api/api.dynamicSetting";
import TextEditor from "../../_Components/CkEditor/Index";
const Index = () => {
  const [body, setBody] = useState();
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
  } = useForm({ id: 0 });

  useEffect(() => {
    (async () => {
      try {
        let response = await ApiDynamicSetting.getAboutUs();
        if (response.succeeded) {
          setValue("id", response.data.id);
          setBody(response.data.text);
          setValue("desc", response.data.desc);
          setValue("type", response.data.type);
          setValue("textType", response.data.textType);
        }
      } catch (error) {
        console.log("error :>> ", error);
      }
    })();

    return () => {};
  }, []);

  const onSubmit = async (data) => {
    try {
      console.log("onSubmit data:", "");
      let response = await ApiDynamicSetting.createUpdateAboutUs({ id: data.id, text: body, textType: 1 }); //0=HTML 1=Markdown
    } catch (error) {
      console.log("error=", error);
    }
  };

  return (
    <form id="form" onSubmit={handleSubmit(onSubmit)}>
      <div className="App">
        <div className={`card card-custom`}>
          {/* Start Box Header */}
          <div className="card-header border-0 pt-5">
            <h3 className="card-title align-items-start flex-column">
              <span className="card-label font-weight-bolder text-dark">مدیریت صفحه ارتباط با ما</span>
              <span className="text-muted mt-3 font-weight-bold font-size-sm">متن صفحه درباره ما</span>
            </h3>
          </div>

          {/*Start body */}
          <div className="card-body pt-3 pb-0">
            {/* search box */}
            <div className=" pt-3">
              <Controller
                name="Editor"
                control={control}
                rules={{ required: false }}
                render={({ field: { onChange, value } }) => (
                  <TextEditor
                    data={body || ""}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      onChange(data);
                      setBody(data);
                    }}
                  />
                )}
              />
              {errors.Editor && <span>لطفا نام را وارد نمایید</span>}
            </div>
            <div className="py-5">
              <Button variant="success" type="submit" disabled={isSubmitting}>
                {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                <SaveIcon /> ذخیره
              </Button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default Index;
